import { render } from "./ResendDocumentData.vue?vue&type=template&id=2653d84e&scoped=true"
import script from "./ResendDocumentData.vue?vue&type=script&lang=js"
export * from "./ResendDocumentData.vue?vue&type=script&lang=js"

import "./ResendDocumentData.vue?vue&type=style&index=0&id=2653d84e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2653d84e"]])

export default __exports__